import { Empty } from "antd";
import LoanRepaymentCard from "../loanRepayment";
import { useTranslation } from "react-i18next";

export default function LoanRepayHistoryList({ dataSource = [] }) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          {dataSource.map((option, index) => (
            <LoanRepaymentCard record={option} />
          ))}
        </div>
      )}
    </>
  );
}
